// frontend/src/components/features/OAuthCallback.jsx
import { useEffect, useState } from 'react';
import logger from '../../utils/logger';
import { OAUTH_CONFIG } from '../../config/oauth';

/** Time (ms) before showing the manual "Return to App" fallback button */
const FALLBACK_TIMEOUT_MS = 2000;

/**
 * Determine the custom-scheme redirect URL based on the current window location.
 * Exported for unit testing.
 */
export function getCustomRedirectUrl() {
  const hash = window.location.hash;
  const url = window.location.href;

  if (hash && hash.includes('access_token=')) {
    return `${OAUTH_CONFIG.customRedirectUrl}${hash}`;
  }

  if (hash) {
    const params = new URLSearchParams(hash.substring(1));
    const error = params.get('error');
    if (error) {
      return `${OAUTH_CONFIG.customRedirectUrl}${hash}`;
    }
    // Hash present but no token or error
    return '/login';
  }

  if (OAUTH_CONFIG.isRedirectPage(url)) {
    return `${OAUTH_CONFIG.customRedirectUrl}?error=cancelled`;
  }

  return '/login';
}

function OAuthCallback() {
  const [showManualButton, setShowManualButton] = useState(false);

  useEffect(() => {
    const customUrl = getCustomRedirectUrl();

    if (customUrl.startsWith(`${OAUTH_CONFIG.customScheme}://`)) {
      logger.debug('[OAuthCallback] Redirecting to custom URL scheme:', customUrl.substring(0, 100));
      window.location.href = customUrl;

      // If the automatic redirect is blocked (common in some in-app browsers),
      // show a fallback button after a short delay so the user can retry manually.
      const timer = setTimeout(() => {
        setShowManualButton(true);
      }, FALLBACK_TIMEOUT_MS);

      return () => clearTimeout(timer);
    } else {
      // Same-origin redirect (e.g. back to /login)
      window.location.href = customUrl;
    }
  }, []);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
      gap: '20px',
      padding: '0 20px',
      textAlign: 'center'
    }}>
      <div>Processing OAuth callback...</div>
      <div style={{ fontSize: '14px', color: 'var(--text-secondary, #666)' }}>Please wait...</div>

      {showManualButton && (
        <div style={{ marginTop: '12px' }}>
          <p style={{ fontSize: '14px', color: 'var(--text-secondary, #666)', marginBottom: '12px' }}>
            If the app did not open automatically, tap the button below.
          </p>
          <button
            onClick={() => {
              const customUrl = getCustomRedirectUrl();
              window.location.href = customUrl;
            }}
            style={{
              padding: '12px 24px',
              fontSize: '16px',
              backgroundColor: '#4285F4',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Return to App
          </button>
        </div>
      )}
    </div>
  );
}

export default OAuthCallback;
